/*
 * @Author: Ryan
 * @Date: 2025-12-03
 * @Description: SVG icons for SEO sections - central export file
 */
export { StarIcon } from './StarIcon';
